import { arrayOf, node, oneOfType } from 'prop-types';

import styles from './Description.scss';

export const Description = ({ children }) => (
  <p className={styles.Description} data-testid="SectionDescription">
    {children}
  </p>
);

Description.propTypes = {
  children: oneOfType([node, arrayOf(node)]).isRequired,
};
